var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.4033V14.1694C3 14.5886 3.15804 14.9906 3.43934 15.287C3.72064 15.5835 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.5835 14.5607 15.287C14.842 14.9906 15 14.5886 15 14.1694V11.4033M9.00056 11.2069L9.00056 2.25M9.00056 2.25L5.57199 5.67238M9.00056 2.25L12.4291 5.67238",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/upload-white.477f3aeedf087a5708848547048a3a13.svg";
export { ForwardRef as ReactComponent };